import React, { Suspense } from 'react';
import LoadingCircle from '@cpg-its/ads.common.loading-circle';
import { useEpiPageContent } from '../hooks/useEpiPageContent';
import { PageType, TcsmContentPage, TcsmLandingPage, TcsmNewsUpdatesPage, TcsmNotFoundPage, TcsmReportsLandingPage } from '../models/tcsm-page-models';
import { TcsmLandingPageView } from './page-type/tcsm-landing-page';
import { TcsmNewsUpdatesPageView } from './page-type/tcsm-news-updates-page';
import { TcsmNotFoundPageView } from './page-type/tcsm-not-found-page';

const TcsmReportsLandingPageView = React.lazy(() => import('./page-type/tcsm-reports-landing-page'));
const TcsmContentPageView = React.lazy(() => import('./page-type/tcsm-content-page'));

interface Props {
    hideBreadcrumbs?: boolean;
}
export const PageFactory = (props: Props) => {

    const pageData = useEpiPageContent();

    if (!pageData) {
        return <LoadingCircle />;
    }

    switch (pageData?.pageType) {
        case PageType.TCSMLandingPage: {
            return <TcsmLandingPageView pageData={pageData as TcsmLandingPage} />;
        }
        case PageType.TCSMNewsUpdatesPage: {
            return <TcsmNewsUpdatesPageView pageData={pageData as TcsmNewsUpdatesPage} />;
        }
        case PageType.NotFoundPage: {
            return <TcsmNotFoundPageView pageData={pageData as TcsmNotFoundPage} />;
        }

        case PageType.TCSMReportsLandingPage: {
            return <Suspense fallback={<LoadingCircle />}><TcsmReportsLandingPageView pageData={pageData as TcsmReportsLandingPage} /></Suspense>;
        }

        case PageType.TCSMContentPage: {
            return <Suspense fallback={<LoadingCircle />}><TcsmContentPageView pageData={pageData as TcsmContentPage} hideBreadCrumbs={ props?.hideBreadcrumbs}/></Suspense>;
        }

        default: {
            return <>Page Factory</>;
        }
    }
};

PageFactory.defaultProps = {
    hideBreadcrumbs: false,
};